import { Bank } from '../interfaces/bank';

export class BankModel implements Bank {
    bankCode: number;
    bankDescription: string;
    bankName: string;
    constructor() { }
}
